<template>
  <v-card
    class="mx-auto"
    max-width="900"
  >
    <v-card-title>
      Success
    </v-card-title>
    <v-card-text>
      <div>
        Registration was successful.
      </div>
      <div>
        You will be redirected to login page in {{ countDown }} seconds.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RegisterSuccess',

  props: {
    redirectTo: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    countDown: 5,
  }),

  created() {
    this.countDownTimer();
    setTimeout(() => {
      if (this.redirectTo) {
        window.location.href = this.redirectTo;
      } else {
        this.$router.push({ name: 'login' });
      }
    }, 5000);
  },

  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
};
</script>
